 import { Injectable } from '@angular/core';
 import { BehaviorSubject, Observable } from 'rxjs';

 @Injectable({
  providedIn: 'root',
})
export class RacunSaldoService {
  shouldReload$ = new BehaviorSubject<boolean>(false);

  setShouldReload(): void {
   this.shouldReload$.next(true);
  }

  getShouldReload(): Observable<boolean> {
    return this.shouldReload$.asObservable();
  }
}
